import { makeStyles } from '@material-ui/core/styles';
import { variables } from '../../styles';

export const useStyles = makeStyles(() => ({
  root: {
    flex: 1,
  },
  header: {
    fontWeight: 700,
    color: variables.black50,
    fontSize: 12,
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: variables.white,
  },
  container: {
    '& .MuiMenu-paper': {
      width: 400,
      borderRadius: 16,
      padding: 16,

      '& .MuiList-root': {
        paddingTop: 0,
      },
    },
  },
  noNotifications: {
    textAlign: 'center',
    paddingTop: 85,
    paddingBottom: 85,
  },
  button: {
    height: 60,
    gap: 16,
    borderRadius: 8,
    paddingRight: 16,
    paddingLeft: 16,
    fontWeight: 600,
    fontSize: 16,
    color: variables.richBlack,

    '&:hover': {
      color: variables.black50,
      backgroundColor: 'unset',
    },
  },
  buttonContainer: {
    marginTop: 8,
    marginBottom: 8,
  },
}));
